// Iframe controller and fetch recording are in a separate entry, to avoid certain race conditions,
// we make sure it has loaded.
export const whenFetchRecordingReady = (callback: () => void): void => {
  if (window.fetchRecording) {
    callback();
  } else {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setTimeout(() => whenFetchRecordingReady(callback), 100);
  }
};
